import { useNavigate } from "react-router-dom";
import {
  StyledArrow,
  StyledBackBtn,
  StyledBtnText,
  StyledCircle,
} from "./BackButton.style";

export default function BackButton(props) {
  const navigate = useNavigate();
  return (
    <StyledBackBtn
      onClick={() => (props.Route ? navigate(props.Route) : navigate(-1))}
    >
      <StyledCircle aria-hidden="true">
        <StyledArrow></StyledArrow>
      </StyledCircle>
      <StyledBtnText>صفحه قبل </StyledBtnText>
    </StyledBackBtn>
  );
}
